import styled from 'styled-components';
import { slate1 } from '@engage/colors';
import LoadingSpinner from '@members/loading/LoadingSpinner';

export const Loading = styled(LoadingSpinner)`
  display: ${props => (props.isLoading ? 'block' : 'none')};
  fill: ${slate1};
  margin: auto;
`;
